(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kleinpfote-addons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kleinpfote-addons')) {
    customElements.define('kleinpfote-addons', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.rows = Array.from(this.querySelectorAll('[data-kp-addon-row]')).map(element => {
          const data = element.querySelector('[data-kp-addon-variants]');
          let variants = [];
          try { variants = JSON.parse(data?.textContent || '[]'); } catch { variants = []; }
          const image = element.querySelector('img');
          return {
            element,
            variants,
            checkbox: element.querySelector('[data-kp-addon-toggle]'),
            selects: Array.from(element.querySelectorAll('[data-kp-addon-option]')),
            price: element.querySelector('[data-kp-addon-price]'),
            availability: element.querySelector('[data-kp-addon-availability]'),
            originalImage: image?.getAttribute('src'),
            originalSrcset: image?.getAttribute('srcset'),
            touched: false,
          };
        });
        this.addEventListener('change', event => {
          const row = this.rows.find(item => item.element.contains(event.target));
          if (!row) return;
          row.touched = true;
          this.updateRow(row, event.target.matches('select') ? row.selects.indexOf(event.target) : -1);
          this.updateSummary();
        }, { signal: this.controller.signal });
        this.addEventListener('click', event => {
          if (event.target.closest('select, input, label, a, button')) return;
          const row = this.rows.find(item => item.element.contains(event.target));
          if (row?.checkbox && !row.checkbox.disabled) row.checkbox.click();
        }, { signal: this.controller.signal });
        this.form = document.getElementById(this.dataset.formId);
        this.mainInput = this.form?.querySelector('[name="id"]');
        this.mainInput?.addEventListener('change', () => this.syncMainColor(), { signal: this.controller.signal });
        this.syncMainColor();
        if (!this.revealPlayed && typeof IntersectionObserver === 'function' && typeof this.animate === 'function' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.revealObserver = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.revealPlayed = true;
            this.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 350, easing: 'ease-out' });
            this.revealObserver.disconnect();
          }, { threshold: 0.15 });
          this.revealObserver.observe(this);
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.revealObserver?.disconnect();
        this.controller = null;
        this.form?.closest('product-form')?.classList.remove('kp-has-addons');
      }

      syncMainColor() {
        const mainPicker = this.closest('product-info')?.querySelector('variant-selects');
        let mainColor = '';
        for (const fieldset of mainPicker?.querySelectorAll('fieldset') || []) {
          const input = fieldset.querySelector('input:checked');
          const name = input?.name.trim().replace(/-\d+$/, '') || '';
          if (/^(farbe|color|colour|couleur)$/i.test(name)) mainColor = input.value;
        }
        if (!mainColor) {
          for (const select of mainPicker?.querySelectorAll('select') || []) {
            if (/^(farbe|color|colour|couleur)$/i.test(select.name.trim().replace(/^options\[|\]$/g, ''))) mainColor = select.value;
          }
        }
        for (const row of this.rows) {
          if (!row.touched && mainColor) {
            const colorSelect = row.selects.find(select => {
              const label = row.element.querySelector(`label[for="${CSS.escape(select.id)}"]`);
              return /:\s*(farbe|color|colour|couleur)\s*$/i.test(label?.textContent || '');
            });
            if (colorSelect && Array.from(colorSelect.options).some(option => option.value === mainColor)) colorSelect.value = mainColor;
          }
          this.updateRow(row);
        }
        this.updateSummary();
      }

      updateRow(row, changedIndex = -1) {
        if (!row.variants.length) return;
        for (const select of row.selects) select.disabled = false;
        let values = row.selects.map(select => select.value);
        let variant = row.variants.find(item => item.options.every((value, index) => !row.selects.length || value === values[index]));
        if (!variant && changedIndex >= 0) {
          const candidates = row.variants.filter(item => item.options[changedIndex] === values[changedIndex]);
          variant = candidates.find(item => item.available) || candidates[0];
        }
        if (!variant) variant = row.variants.find(item => item.available) || row.variants[0];
        row.selects.forEach((select, index) => { select.value = variant.options[index]; });
        values = variant.options;
        row.selects.forEach((select, index) => {
          for (const option of select.options) {
            option.disabled = !row.variants.some(item => item.options[index] === option.value && item.options.every((value, position) => position >= index || value === values[position]));
          }
        });
        row.variant = variant;
        row.checkbox.disabled = !variant.available;
        if (!variant.available) row.checkbox.checked = false;
        row.price.textContent = variant.formattedPrice;
        row.availability.hidden = variant.available;
        const image = row.element.querySelector('img');
        if (image) {
          if (variant.image) {
            image.removeAttribute('srcset');
            image.src = variant.image;
          } else {
            image.src = row.originalImage;
            if (row.originalSrcset) image.srcset = row.originalSrcset;
            else image.removeAttribute('srcset');
          }
        }
      }

      getSelectedItems() {
        return this.rows.filter(row => row.checkbox.checked && !row.checkbox.disabled && row.variant?.available).map(row => ({ id: row.variant.id, quantity: 1 }));
      }

      updateSummary() {
        const selected = this.rows.filter(row => row.checkbox.checked && !row.checkbox.disabled && row.variant?.available);
        const total = selected.reduce((sum, row) => sum + row.variant.price, 0);
        const summary = this.querySelector('[data-kp-addons-total]');
        summary.hidden = !selected.length;
        if (selected.length) {
          let price;
          try { price = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency }).format(total / 100); }
          catch { price = (total / 100).toFixed(2) + ' ' + this.dataset.currency; }
          summary.textContent = this.dataset.totalLabel + ': ' + price;
        }
        this.form?.closest('product-form')?.classList.toggle('kp-has-addons', selected.length > 0);
        this.querySelector('[data-kp-addons-announcement]').textContent = '';
      }

      announceAdded() {
        this.querySelector('[data-kp-addons-announcement]').textContent = this.dataset.addedMessage;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
